import { FocusEventHandler, useRef } from 'react'
import ggoTryStyles from './ggo-try.module.scss'

export const GGOTryComponent = () => {
  const selectedFirstTime = useRef(false)
  const selectTextAreaText: FocusEventHandler<HTMLTextAreaElement> = (event) => {
    if (selectedFirstTime.current) {
      return
    }

    const target = event.target as HTMLTextAreaElement

    target.select()
    selectedFirstTime.current = true
  }
  const placeholderText =
    'Hey Nahva, I can’t believe its your birthday already again so soon! Your a really special person to me and I hope you have a really good day. Enjoy your birthday with fun and celebration!'

  return (
    <div className={ggoTryStyles.container}>
      <textarea
        id="ggoTryTextArea"
        className={ggoTryStyles.textArea}
        onFocus={selectTextAreaText}
        defaultValue={placeholderText}
      />
    </div>
  )
}
